import type { Alert } from '@atlassian/eoc-alert-common';
import { fetch } from '@atlassian/eoc-fetch';

type fetchAlertsParams = {
	searchParams?: Record<string, any>;
};

export const fetchAlerts = async ({ searchParams }: fetchAlertsParams) => {
	const params = new URLSearchParams(searchParams ?? {});
	return fetch<{
		count: number;
		offset: number;
		values: Alert[];
	}>(`/v1/alerts/?${params.toString()}`);
};
